import React from 'react';
import { createRoot } from 'react-dom/client';
import * as pt from 'prop-types';
import { Form, FormField, Input, Label } from 'semantic-ui-react';

import { forceImageUpdate } from '../../CornerstoneTools/forceImageUpdate';

class FloatingInputCallback extends React.PureComponent {
  constructor(props) {
    super(props);
    const { defaultValue } = props;
    this.state = {
      value: defaultValue || '',
    };
    this.inputRef = undefined;
    this.submitted = false;
  }

  componentDidMount = () => {
    this.inputRef.focus();
  };

  setInputRef = (e) => {
    this.inputRef = e;
  };

  onSubmit = () => {
    this.submitted = true;
    const { getTextCallback } = this.props;
    const { value } = this.state;
    getTextCallback(value);
  };

  onBlur = () => {
    if (this.submitted) return;
    const { defaultValue, getTextCallback } = this.props;
    const { value } = this.state;
    getTextCallback(value || defaultValue || undefined);
  };

  render = () => {
    const { value } = this.state;
    const { top, left, inputProps, title } = this.props;
    return (
      <div
        style={{
          position: 'fixed',
          top,
          left,
        }}
      >
        <Form onSubmit={this.onSubmit}>
          <FormField inline>
            <Input
              label={title}
              value={value}
              ref={this.setInputRef}
              onBlur={this.onBlur}
              onChange={(e, { value: inputValue }) => this.setState({ value: inputValue })}
              type="text"
              {...inputProps}
            />
          </FormField>
        </Form>
      </div>
    );
  };
}

FloatingInputCallback.propTypes = {
  getTextCallback: pt.func.isRequired,
  top: pt.number.isRequired,
  left: pt.number.isRequired,
  defaultValue: pt.string,
  inputProps: pt.shape({}),
  title: pt.string,
};

FloatingInputCallback.defaultProps = {
  defaultValue: null,
  inputProps: undefined,
  title: undefined,
};

export default FloatingInputCallback;

const addInputBox = (
  doneChangingTextCallback,
  eventData,
  { defaultValue = undefined, inputProps = undefined, title = undefined } = {}
) => {
  const inputBoxContainer = document.createElement('div');
  document.body.appendChild(inputBoxContainer);

  const getTextCallback = (text) => {
    doneChangingTextCallback(text);
    document.body.removeChild(inputBoxContainer);
    forceImageUpdate(eventData.element);
  };

  const { clientX, clientY } = eventData.event;

  const root = createRoot(inputBoxContainer);

  root.render(
    <FloatingInputCallback
      title={title}
      defaultValue={defaultValue}
      inputProps={inputProps}
      left={clientX}
      top={clientY}
      getTextCallback={getTextCallback}
    />
  );
};

export { addInputBox };
